import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";
import {useSelector} from "react-redux";

export const useOkienkoSprawozdania = () => {
    const rola = useSelector((state) => state.user.role);
    const roleParam = rola === 'oper' ? 'oper/' : '';

    return useQuery({
        queryKey: ['okienko_sprawozdania', rola],
        queryFn: () => getData(`/${roleParam}sprawozdanie/okienko`),
        staleTime: 5 * 60 * 1000,
    })
}
